import React from 'react';

/**
 * Thumbnail/section representing the compatible category
 *
 * @param props
 * @returns {*}
 * @constructor
 */
function CompatibleProduct(props) {
  return (
    <div
      className={
        'xrs-category' + (props.isActive ? ' xrs-category--active' : '')
      }
      onClick={props.onClick}
    >
      {props.categoryImageUrl ? (
        <img
          src={props.categoryImageUrl}
          className="xrs-category__image"
          alt={props.categoryName}
        />
      ) : (
        ''
      )}
      <div className="xrs-category__name">{props.categoryName}</div>
      <div className="xrs-category__chevron">
        <svg enableBackground="new 0 0 40 20" viewBox="0 0 40 20">
          <path d="m33.7 2.4c-0.8-0.8-2-0.8-2.8 0l-10.9 10.9-10.9-10.9c-0.8-0.8-2-0.8-2.8 0s-0.8 2 0 2.8l12.3 12.3c0.4 0.4 0.9 0.6 1.4 0.6s0 0 0 0c0.5 0 1-0.2 1.4-0.6l12.3-12.2c0.8-0.8 0.8-2.1 0-2.9z" />
        </svg>
      </div>
    </div>
  );
}

export default CompatibleProduct;
